import { Box, Grid } from "@mui/material";
import { motion } from "motion/react";
import { Space } from "~/lib/types";
import { Link as RouterLink } from "react-router-dom";
import { ActiveFrameworkCard } from "./ActiveFrameworkCard";
import { ComplianceFramework, FrameworksData } from "../types";

type ActiveFrameworksProps = {
  space: Space;
  data: FrameworksData;
};

export function ActiveFrameworks({ space, data }: ActiveFrameworksProps) {
  const activeFrameworks = data.edges
    ?.map((edge) => edge?.node)
    ?.filter((x): x is ComplianceFramework => x !== null);

  return (
    <Box
      component={motion.div}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      sx={{ width: 1 }}
    >
      <Grid container spacing={3}>
        {activeFrameworks?.map((framework) => {
          return (
            <Grid
              key={framework.mrn}
              size={{
                xs: 12,
                sm: 12,
                md: 6,
              }}
            >
              <RouterLink
                to={`${framework.mrn.split("/").pop()}?spaceId=${
                  space.id
                }&frameworkMrn=${framework.mrn}`}
              >
                <ActiveFrameworkCard
                  {...{
                    space,
                    framework,
                  }}
                />
              </RouterLink>
            </Grid>
          );
        })}
      </Grid>
    </Box>
  );
}
